import { AxiosRequestConfig } from 'axios'
import {
  DashboardLogin,
  DashboardSession,
} from '@/typings/api/Dashboard'
import {
  BaseApiResponseCollection as BRC,
} from '@/typings/common'

import { BaseApi } from '@/api/BaseApi'


export class MonitoringDashboardsApiAuth extends BaseApi<DashboardLogin> {
  protected readonly endpoint = 'auth-service-lk-new/auth/api/sessions/';

  constructor(
    protected readonly baseURL = BaseApi.getDefaultBaseURL(),
    protected readonly endpointPrefix = '/',
  ) {
    super(baseURL, endpointPrefix)
  }

  public getLogins(params?: unknown, config: AxiosRequestConfig = {}) {
    const path = 'daily_activity_stat/'
    const [url] = this.getUrl(path)
    return this.request<unknown, BRC<DashboardLogin>>('GET', url, { params, ...config })
  }

  public getSessions(params?: unknown, config: AxiosRequestConfig = {}) {
    const path = 'hourly_activity_stat/'
    const [url] = this.getUrl(path)
    return this.request<unknown, BRC<DashboardSession>>('GET', url, { params, ...config })
  }
}
